const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    height: '100%',
  },
  noResults: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '20px 0',
  },
  table: {
    width: '100%',
    borderSpacing: 0,
    padding: '0 0 10px 0',
    border: '1px solid #e8e8e8',
    '& tr': {
      '&:hover': {
        backgroundColor: 'rgba(0,152,69,0.17) !important',
      },
    },
  },
  th: {
    textAlign: 'left',
    position: 'sticky',
    top: 0,
    background: '#F9F9F9',
    zIndex: 10,
    padding: '10px 5px 20px 5px',
  },
  'tr:nth-child(odd)': {
    backgroundColor: '#f6f6f6',
  },
  td: {
    paddingRight: '1em',
    color: '#414141',
    fontSize: '13px',
    paddingLeft: '5px',
    minWidth: '100px',
    paddingTop: '4px',
    paddingBottom: '4px',
  },
  tableWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: '800px',
    overflow: 'auto',
  },
  tableFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    '& p': {
      color: '#424242',
    },
  },
  checkbox: {
    textAlign: 'center',
    padding: '4px 8px',
    cursor: 'pointer',
    '& input': {
      cursor: 'pointer',
    },
    '& input:checked': {
      filter: 'hue-rotate(240deg)',
    },
  },
  '@media (max-width: 760px)': {
    tableWrapper: {
      maxHeight: '400px',
    },
  },
};

export default styles;

